export const keyboardEvents = {
  ENTER: {
    keyCode: 13,
    charCode: 13
  },
  SPACEBAR: {
    keyCode: 32,
    charCode: 13
  },
  ARROW_UP: {
    keyCode: 38,
    charCode: 38
  },
  ARROW_DOWN: {
    keyCode: 40,
    charCode: 40
  },
  ARROW_RIGHT: {
    keyCode: 39,
    charCode: 39
  },
  ARROW_LEFT: {
    keyCode: 37,
    charCode: 37
  },
  TAB: {
    keyCode: 9,
    charCode: 9
  }
};
//# sourceMappingURL=constants.js.map